<template>
  <section class="minimized-call" v-if="shouldPresent"
           v-bind:class="{'pill-collapse': isCollapsed,
           'not-in-correct-active-appointment': isNotInCorrectActiveAppointmentPage && !userIsAcceptee,
            'minimized-call-no-height': userIsAcceptee}"
           :style="`top: calc(${8.25*$vnode.key}rem + 65px);`">

    <div v-if="activeState && activeRequest.appointment && hasStartedCountingTime"
         :class="{'row near-end-bar near-end-yellow': secondsRemainToEnd < 600 && secondsRemainToEnd > 300, 'row near-end-bar near-end-red': secondsRemainToEnd < 300}"/>
    <div class="collapsable-div">
      <i v-if="isCollapsed" class="fa fa-chevron-left clickable" v-on:click="handleCollapse"></i>
      <i v-else class="fa fa-chevron-right clickable" v-on:click="handleCollapse"></i>
    </div>

    <div class="appointment-call-minimized default"
         v-show="(!$route.path.includes('/active-appointment') && defaultState) && (activeAppointments && activeAppointments.length > 0) && hasPermissionToCreateRequest"
         key="1">
      <div v-if="!isInAppointmentOrRequestPage && (activeAppointments && activeAppointments.length === 1)"
           class="active-appointment-warning" @click="onClickGetBack">
        <small class="is-bold">
          {{
            $t('clinical.people.appointments.active_appointment_warning_message', {person: this.activeAppointments[0].person.name})
          }}
        </small>
        <br>
        <small class="is-bold">
          {{
            $t('clinical.appointments.active_appointment_warning_2', {start: $options.filters.localTime(this.activeAppointments[0].start, `DD [${$t('date_helpers.day_of_month_separator')}] MMMM [${$t('date_helpers.day_of_month_separator')}] YYYY - HH:mm`, '', this.locale)})
          }}
        </small>
      </div>

      <div v-if="!isInAppointmentOrRequestPage && activeAppointments && activeAppointments.length > 1"
           class="active-appointment-warning" @click="onClickMultipleAppointments">
        <small class="is-bold">
          {{
            $t('clinical.people.appointments.active_appointments_simultaneous_warning_message', {count: this.activeAppointments.length})
          }}
        </small>
      </div>

      <va-button
        v-else-if="availableEntitiesOnline && !activeRequest && $route.path.includes('/anamnesis/edit')"
        id="btn-create-request"
        key="btn-create-request"
        color="success"
        @click="onClickCreateRequest">
        {{ $t('clinical.appointments.create_call_request') }}
      </va-button>

      <small v-else-if="!activeRequest && $route.path.includes('/anamnesis/edit')" class="is-bold">
        {{ $t('clinical.appointments.waiting_for_audiologist') }}
      </small>
    </div>

    <div class="appointment-call-minimized default" v-show="defaultState && userIsActiveAudiologist" key="2">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <small class="is-bold text-small">{{ $t('evocall.requests.activity_state') }}:</small>
          <small class="is-bold text-small ml-4">{{
              inBreak ? $t('evocall.requests.activity_state_suspended') : $t('evocall.requests.activity_state_active')
            }}</small>
          <Slider class="ml-4" :disabled="isTogglingBreak" :checked="!inBreak" @change="toggleBreak"></Slider>
        </div>
        <div class="d-flex align-items-center pt-3 pl-4">
          <div class="d-flex">
            <va-popover
              placement="top"
              :message="$t('evocall.dashboard.online_audiologists')">
              <i class="i-waiting-room-online-audiologists svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ onlineAudiologists }} </span>
            </va-popover>
          </div>


          <div class="ml-4 d-flex">
            <va-popover
              placement="top"
              :message="$t('evocall.dashboard.on_going')">
              <i class="i-waiting-room-in-consultation svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ metrics.ongoingCalls }} </span>
            </va-popover>

          </div>


          <div class="ml-4 d-flex">
            <va-popover
              placement="top"
              :message="$t('evocall.dashboard.waiting_time')">
              <i class="i-waiting-room-waiting svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ requests.length }} </span>
            </va-popover>
          </div>
        </div>


      </div>

    </div>

    <div class="appointment-call-minimized pending" v-if="pendingState && pendingRequest.appointment" key="3">
      <div class="call-informations-wrapper">
        <div class="call-informations">

          <div class="container_call">
            <!--Left div-->
            <div class="info_call_left">
              <!-- Top left line-->
              <div class="d-flex flex-column align-items-center info_call_left_top">
                <span class="is-bold text-success">
                  {{ $t('clinical.appointments.waiting_for_call_for') }}
                </span>
              </div>

              <!-- Bottom left line-->
              <div class="d-flex flex-column align-items-center info_call_left_bottom">
                <span class="is-bold text-success"
                      v-if="pendingRequest && pendingRequest.appointment && pendingRequest.appointment.person">
                  {{ pendingRequest.appointment.person.name }}
                </span>
                <small class="text-success">{{ $t('clinical.appointments.waiting_for_call_time_remaining') }}:</small>
              </div>
            </div>

            <!-- Right div/Right line-->
            <div class="d-flex flex-column align-items-center info_call_right">
              <span
                v-if="!$route.path.includes(pendingRequest.appointment.parent_id ? pendingRequest.appointment.parent_id : pendingRequest.appointment.id+'/anamnesis/edit')"
                class="ml-2 clickable text-success" @click="onClickGetBack">
                    <va-popover :message="$t('clinical.appointments.go_back_to_anamnesis')" placement="top">
                      <i class="fa fa-external-link"></i>
                    </va-popover>
                  </span>
            </div>
          </div>

          <div class="estimated-waiting-time d-flex"
               v-if="estimatedTimeUntilAcceptance !== null && estimatedTimeToAcceptance !== null && estimatedTimeToAcceptance.minutes() >= 1">
            <div class="d-flex flex-column align-items-center" v-if="estimatedTimeToAcceptance.hours() > 0">
              <span class="time-unit is-bold">{{ withLeadingZero(estimatedTimeToAcceptance.hours()) }}</span>
              <small class="time-unit-desc">{{ $t('time.hours') }}</small>
            </div>

            <span class="time-unit-separator mx-1" v-if="estimatedTimeToAcceptance.hours() > 0">:</span>

            <div class="d-flex flex-column align-items-center">
              <span class="time-unit is-bold">{{ withLeadingZero(estimatedTimeToAcceptance.minutes()) }}</span>
              <small class="time-unit-desc">{{ $t('time.min') }}</small>
            </div>

            <span class="time-unit-separator mx-1">:</span>

            <div class="d-flex flex-column align-items-center">
              <span class="time-unit is-bold">{{ withLeadingZero(estimatedTimeToAcceptance.seconds()) }}</span>
              <small class="time-unit-desc">{{ $t('time.sec') }}</small>
            </div>
          </div>

          <div v-else class="estimated-waiting-time time-unit-separator">
            <span class="is-bold">
              {{ $t('clinical.appointments.call_in_a_few_moments') }}...
            </span>
          </div>

        </div>

      </div>

      <div class="cancel-call-wrapper">
        <va-popover
          placement="left"
          :message="$t('clinical.appointments.cancel_call')"
        >
          <va-button
            id="btn-cancel"
            large
            class="va-button-rounded"
            icon="fa fa-phone"
            @click="onClickCancel"
          >
          </va-button>
        </va-popover>
      </div>

    </div>

    <div class="appointment-call-minimized active" v-if="activeState && activeRequest.appointment" key="4">

      <div class="call-wrapper">
        <div class="call-informations-wrapper">
          <div class="call-informations">

            <div class="container_call">
              <!--Left div-->
              <div class="info_call_left">
                <!-- Top left line-->
                <div class="d-flex flex-column align-items-center info_call_left_top">
                  <span>{{ $t('clinical.appointments.in_call_with') | upperCase }}</span>
                </div>

                <!-- Bottom left line-->
                <div class="d-flex flex-column align-items-center info_call_left_bottom">
                  <span> {{ activeRequest.appointment.person.name }} </span>
                  <small class="call-user">{{ userIsAcceptee ? creator.name : acceptee.name }}</small>
                </div>
              </div>

              <!-- Right div/Right line-->
              <div class="d-flex flex-column align-items-center info_call_right">
              <span
                v-if="(!userIsAcceptee && !$route.path.includes(activeRequest.appointment.parent_id ? activeRequest.appointment.parent_id : activeRequest.appointment.id+'/anamnesis/edit'))
                || (userIsAcceptee && activeRequest.call && !$route.path.includes(`evocall/requests/${activeRequest.call.id}`))"
                class="ml-2 clickable" @click="onClickGetBack">
                  <va-popover :message="$t('clinical.buttons.resume_appointment')" placement="top">
                    <i class="fa fa-external-link"></i>
                  </va-popover>
                </span>
              </div>
            </div>

            <div class="call-duration" v-if="callDuration !== null">
              <span>{{ getDurationString(callDuration.asSeconds(), 'seconds', true, ' : ', false) }}</span>
            </div>
          </div>

          <div class="call-actions" v-if="userIsAcceptee">
            <span>{{ $t('evocall.requests.estimated_duration') }}:
              <span
                :class="{'near-end-yellow-text': secondsRemainToEnd < 600 && secondsRemainToEnd > 300, 'near-end-red-text': secondsRemainToEnd < 300}">
                {{ secondsRemainToEnd > 300 ? `${activeRequest.call.estimated_duration} min.` : $t('evocall.requests.5_min_remaining') }}
              </span>
              <i v-if="secondsRemainToEnd < 600"
                 :class="{'fa fa-warning near-end-yellow-text': secondsRemainToEnd < 600 && secondsRemainToEnd > 300, 'fa fa-warning near-end-red-text' : secondsRemainToEnd < 300}"></i>
            </span>
            <!--<span :class="{'near-end': isNearEnd}"> {{ activeRequest.call.estimated_duration }} min.</span>&nbsp;-->
            <!--<i v-if="isNearEnd" class="fa fa-warning near-end"></i></span>-->

            <div class="call-action-buttons">
              <va-popover
                placement="bottom"
                :message="$t('evocall.requests.actions.update_estimated_duration')"
                :popoverClasses="['evollu-color']"
                :popoverStyles="{'border-radius': 0, 'color': 'white'}"
                backgroundColor="#29c4a9">
                <i class="fa fa-clock-o" @click.prevent="onClickUpdateEstimatedDuration"></i>
              </va-popover>
              <va-popover
                placement="bottom"
                :message="$t('evocall.requests.actions.requeue')"
                :popoverClasses="['evollu-color']"
                :popoverStyles="{'border-radius': 0, 'color': 'white'}"
                backgroundColor="#29c4a9">
                <i class="fa fa-history" @click.prevent="onClickRequeueCall"></i>
              </va-popover>

            </div>

          </div>

          <div class="d-flex align-items-center pt-3 pl-4" v-if="userIsAcceptee">
            <div class="d-flex">
              <va-popover
                placement="top"
                :message="$t('evocall.dashboard.online_audiologists')">
                <i class="i-waiting-room-online-audiologists svg-kpi"></i>&nbsp;
                <span class="kpi-content">  {{ onlineAudiologists }} </span>
              </va-popover>
            </div>


            <div class="ml-4 d-flex">
              <va-popover
                placement="top"
                :message="$t('evocall.dashboard.on_going')">
                <i class="i-waiting-room-in-consultation svg-kpi"></i>&nbsp;
                <span class="kpi-content">  {{ metrics.ongoingCalls }} </span>
              </va-popover>

            </div>


            <div class="ml-4 d-flex">
              <va-popover
                placement="top"
                :message="$t('evocall.dashboard.waiting_time')">
                <i class="i-waiting-room-waiting svg-kpi"></i>&nbsp;
                <span class="kpi-content">  {{ requests.length }} </span>
              </va-popover>
            </div>
          </div>

        </div>

        <div class="end-call-wrapper">
          <va-popover
            placement="left"
            :message="$t('clinical.appointments.dismiss_call')"
          >
            <va-button
              id="btn-dismiss"
              large
              class="va-button-rounded"
              icon="fa fa-phone"
              @click="onClickEndCall"
            >
            </va-button>

          </va-popover>

        </div>

      </div>

      <div v-if="hasUnsavedChanges" class="unsaved-changes-wrapper">
        <small class="is-bold text-white">{{ $t('clinical.appointments.has_unsaved_changes') }}</small>
      </div>
    </div>

    <RequestCallForm
      v-if="isCreatingRequest"
      :appointment="currentActiveAppointment"
      :service="authClinicalService"
      @modal-closed="onCallRequestModalClosed"
    />

    <RateCallRequest
      v-if="callHasEnded && activeRequest && activeRequest.call && activeRequest.appointment"
      :request="activeRequest.call"
      :appointment="activeRequest.appointment"
      :memberType="userIsAcceptee ? 'acceptee' : 'creator'"
      :authClinicalService="authClinicalService"
      @rate-submitted="onRateModalClosed"
      @cancel="onRateModalClosed"/>

    <UpdateEstimatedDuration
      v-if="isUpdatingEstimatedDuration"
      :request="activeRequest.call"
      @request-updated="onEstimatedDurationUpdated"
      @cancel="onUpdateEstimatedDurationModalClosed"
    />

    <CancelCallRequestModal
      v-if="pendingRequest && isCancelingPendingRequest"
      :request="pendingRequest.call"
      :service="authClinicalService"
      @request-canceled="onRequestCanceled"
      @operation-not-permited="onRequestCancelOperationNotPermited"
      @modal-closed="onCancelPendingRequestModalClosed"
    />

    <ConfirmationModal
      v-if="confirmationModalOptions.display"
      :title="hasUnsavedChanges ? this.$t('clinical.people.anamnesis.modal_has_unsaved_changes_title') : undefined"
      :body="confirmationModalOptions.message"
      @modal-confirmed="modalConfirmed"
      @modal-canceled="resetConfirmationModals"
    />

  </section>
</template>

<script>
import * as _ from 'lodash'
import RateCallRequest from './RateCallRequest'
import EventBus from '@/utils/EventBus'
import Slider from '@/components/common/Slider'
import RequestCallForm from './RequestCallForm'
import {mapActions, mapGetters, mapState} from 'vuex'
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
import UpdateEstimatedDuration from './UpdateEstimatedDuration'
import {BreakService, RequestService} from '@/api/EvocallService'
import ConfirmationModal from '@/components/common/ConfirmationModal'
import CancelCallRequestModal from '@/components/clinical/calls/CancelCallRequestModal'

const AppointmentDetailsInfoType = 300
const CallRequestDetailsInfoType = 200
const WriteAccessType = 2
export default {
  props: {
    authClinicalService: {
      type: Object,
      required: true
    }
  },
  components: {
    Slider,
    RateCallRequest,
    RequestCallForm,
    ConfirmationModal,
    UpdateEstimatedDuration,
    CancelCallRequestModal
  },
  mixins: [
    RelativeTimeMixin,
    CurrentLocaleMixin
  ],
  computed: {
    ...mapGetters({
      userIsActiveAudiologist: 'auth/userIsActiveAudiologist'
    }),
    ...mapState({
      currentActiveAppointment(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/currentActiveAppointment`] || null
      },
      activeAppointments(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeAppointments`] || null
      },
      pendingRequest(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/pendingRequest`] || null
      },
      activeRequest(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeRequest`] || null
      },
      onlineAudiologistsByEntity(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/onlineAudiologistsByEntity`] || null
      },
      inBreak(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/inBreak`] || null
      },
      activeBreak(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeBreak`] || null
      },
      activeRequestHasUnsavedPersonChanges(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeRequestHasUnsavedPersonChanges`] || false
      },
      activeRequestHasUnsavedAppointmentChanges(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeRequestHasUnsavedAppointmentChanges`] || false
      },
      evocallService(state) {
        return state.services.find(service => service.url === state.evocall_server) || null
      },
      isCollapsed(state) {
        return state[this.waitingRoomModuleKey].minimizedCallCollapsed
      },
      metrics(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/metrics`] || null
      },
      requests(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/sortedRequests`]
      },
    }),
    onlineAudiologists: function (value) {
      if (Array.isArray(this.onlineAudiologistsByEntity) && this.onlineAudiologistsByEntity.length > 0) {
        return this.onlineAudiologistsByEntity
          .filter(obj => obj.hasOwnProperty('onlineAudiologists'))
          .reduce((a, b) => {
            return a + b.onlineAudiologists
          }, 0)
      }
      return 0
    },
    ...mapState('auth', []),
    shouldPresent: function () {
      return (this.userIsActiveAudiologist || (!this.$route.path.includes('/active-appointment') && (this.activeAppointments && this.activeAppointments.length > 0)) || (this.pendingState && this.pendingRequest.appointment) || (this.activeState && this.activeRequest.appointment))
    },
    waitingRoomModuleKey: function () {
      return `waiting-room-${this.authClinicalService.slug}`
    },
    hasUnsavedChanges: function () {
      return this.activeRequestHasUnsavedPersonChanges || this.activeRequestHasUnsavedAppointmentChanges
    },
    writeRequestsEntities: function () {
      if (this.evocallService && this.evocallService.hasOwnProperty('user_permissions')) {
        let permissions = this.evocallService.user_permissions.filter(p => p.access_type >= WriteAccessType && p.info_type === CallRequestDetailsInfoType)
        if (permissions.length > 0) {
          if (permissions.some(p => p.entity_id === null)) {
            return [...this.evocallService.entities]
          } else {
            return this.evocallService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
          }
        }
        return []
      }
      return false
    },
    availableEntitiesOnline: function () {
      if (this.evocallService && this.evocallService.hasOwnProperty('entities')) {
        return this.writeRequestsEntities.some(entity => {
          return this.onlineAudiologistsByEntity.some(element => {
            return element.entity_id === entity.id && element.onlineAudiologists - element.audiologistsInBreak > 0
          })
        })
      }
      return false
    },
    pendingCallRequestAppointment: function () {
      return _.get(this.pendingRequest, 'appointment', null)
    },
    estimatedTimeUntilAcceptance: function () {
      let estimatedTimeToAcceptance = _.get(this.pendingRequest, 'call.estimated_accept_time')
      return estimatedTimeToAcceptance !== null ? this.moment(estimatedTimeToAcceptance) : null
    },
    callHasBeenAccepted: function () {
      return _.get(this.activeRequest, 'call.accepted_at', null) !== null
    },
    callHasEnded: function () {
      return _.get(this.activeRequest, 'call.ended_at', null) !== null
    },
    acceptee: function () {
      return _.get(this.activeRequest, 'call.acceptee', null)
    },
    creator: function () {
      return _.get(this.activeRequest, 'call.creator', null)
    },
    hasPermissionToCreateRequest: function () {
      if (this.authClinicalService && this.evocallService) {
        return this.authClinicalService.user_permissions.some(up => up.info_type === AppointmentDetailsInfoType && up.access_type >= WriteAccessType) &&
          this.evocallService.user_permissions.some(up => up.info_type === CallRequestDetailsInfoType && up.access_type >= WriteAccessType)
      }
      return false
    },
    defaultState: function () {
      return this.pendingRequest === null && this.activeRequest === null
    },
    pendingState: function () {
      return this.pendingRequest !== null && !this.callHasBeenAccepted && !this.callHasEnded
    },
    activeState: function () {
      return this.activeRequest !== null && this.callHasBeenAccepted && !this.callHasEnded
    },
    userIsAcceptee: function () {
      return this.acceptee !== null && this.acceptee.id === this.$auth.user().id
    },
    getBackRoute: function () {
      if (this.userIsAcceptee && this.activeRequest && this.evocallService) {
        return {
          name: `${this.authClinicalService.slug}evocall/requests/id`,
          params: {id: this.activeRequest.call.id}
        }
      }
      if (this.pendingRequest && this.pendingRequest.appointment) {
        let pendingRequestAppointmentId = this.pendingRequest.appointment.parent_id ? this.pendingRequest.appointment.parent_id : this.pendingRequest.appointment.id
        if (!this.$route.path.includes(pendingRequestAppointmentId + '/anamnesis/edit')) {
          return {
            name: `${this.authClinicalService.slug}clinical/appointments/:id/anamnesis/edit`,
            params: {id: pendingRequestAppointmentId}
          }
        }
      }

      if (this.activeRequest && this.activeRequest.appointment) {
        let activeRequestAppointmentId = this.activeRequest.appointment.parent_id ? this.activeRequest.appointment.parent_id : this.activeRequest.appointment.id
        if (!this.$route.path.includes(activeRequestAppointmentId + '/anamnesis/edit')) {
          return {
            name: `${this.authClinicalService.slug}clinical/appointments/:id/anamnesis/edit`,
            params: {id: activeRequestAppointmentId}
          }
        }
      }

      if (!this.userIsAcceptee && ((this.activeAppointments && this.activeAppointments.length === 1) || this.currentActiveAppointment) && this.authClinicalService) {
        return {
          name: `${this.authClinicalService.slug}clinical/appointments/:id/anamnesis/edit`,
          params: {id: this.currentActiveAppointment ? this.currentActiveAppointment.id : this.activeAppointments[0].id}
        }
      }
      return null
    },
    isInAppointmentOrRequestPage: function () {
      if (this.currentRoute.path.includes('active-appointments') && (this.activeState || this.pendingState)) {
        return true
      }
      if (this.currentRoute.path.includes('active-appointments') && this.defaultState) {
        return true
      }

      if (this.currentRoute !== null && this.getBackRoute) {
        return this.getBackRoute.name === _.get(this.currentRoute, 'name', null) && parseInt(_.get(this.currentRoute, 'params.id', null)) === this.getBackRoute.params.id
      }

      return this.currentRoute.path.includes('anamnesis/edit')
    },
    isNotInCorrectActiveAppointmentPage: function () {
      // verificar se está na página edit de uma anamnese: this.$route.path.includes("/anamnesis/edit))
      // if(this.$route.path.includes("/anamnesis/edit")){
      // estando, verificar se existe o pending request appointment
      if (this.pendingRequest && this.pendingRequest.appointment) {
        let pendingRequestAppointmentId = this.pendingRequest.appointment.parent_id ? this.pendingRequest.appointment.parent_id : this.pendingRequest.appointment.id
        if (!this.$route.path.includes(pendingRequestAppointmentId + '/anamnesis/edit')) {
          return true
        }
      } else if (this.activeRequest && this.activeRequest.appointment) {
        let activeRequestAppointmentId = this.activeRequest.appointment.parent_id ? this.activeRequest.appointment.parent_id : this.activeRequest.appointment.id
        if (!this.$route.path.includes(activeRequestAppointmentId + '/anamnesis/edit')) {
          // desenhar laranja
          return true
        }
      }
    }
  },
  data: function () {
    return {
      isCreatingRequest: false,
      isUpdatingEstimatedDuration: false,
      isCancelingPendingRequest: false,
      isNearEnd: false,
      hasStartedCountingTime: false,
      secondsRemainToEnd: null,
      currentRoute: null,
      confirmationModalOptions: {
        message: null,
        action: null,
        display: false
      },
      isTogglingBreak: false,
      estimatedTimeToAcceptance: null,
      estimatedTimeTicker: null,
      callDuration: null,
      callDurationTicker: null
    }
  },
  created: function () {
    this.isTogglingBreak = true
    this.loadAuthUserEntityActivityRecords()
    setTimeout(() => {
      this.$store.dispatch(`${this.waitingRoomModuleKey}/RELOAD_MODULE`)
      this.isTogglingBreak = false
    }, 1500)

  },
  methods: {
    ...mapActions('auth', {
      loadAuthUserEntityActivityRecords: 'LOAD_AUTH_USER_ENTITY_ACTIVITIES'
    }),
    handleCollapse: function () {
      this.$store.commit(`${this.waitingRoomModuleKey}/HANDLE_MINIMIZED_CALL_COLLAPSED`)
    },
    onClickCreateRequest: function () {
      this.isCreatingRequest = true
    },
    onCallRequestModalClosed: function () {
      this.isCreatingRequest = false
    },
    onClickCancel: function () {
      this.isCancelingPendingRequest = true
    },
    onClickEndCall: function () {
      this.confirmationModalOptions = {
        message: this.$t('clinical.people.appointments.end_call_confirmation_message'),
        action: 'endCall',
        display: true
      }
    },
    onClickUpdateEstimatedDuration: function () {
      this.isUpdatingEstimatedDuration = true
    },
    onEstimatedDurationUpdated: function (request) {
      this.$store.commit(`${this.waitingRoomModuleKey}/SET_ACTIVE_REQUEST_CALL`, {call: request})
    },
    onUpdateEstimatedDurationModalClosed: function () {
      this.isUpdatingEstimatedDuration = false
    },
    confirmEndCall: function () {
      if (this.activeRequest && this.activeRequest.call) {
        RequestService.end(this.activeRequest.call.id)
          .then(appointment => {
            this.$forceUpdate()
          })
          .catch(errors => {
            this.showToast(this.$t('clinical.appointments.end_call_request_failed'), this.$store.state.errorToastOptions)
            if (errors.hasOwnProperty('response') && errors.response.status === 406) {
              this.$store.dispatch(`${this.waitingRoomModuleKey}/RELOAD_MODULE`)
            }
          })
      }
    },
    onClickRequeueCall: function () {
      this.confirmationModalOptions = {
        message: this.hasUnsavedChanges ? this.$t('clinical.people.anamnesis.modal_has_unsaved_changes') : this.$t('evocall.requests.actions.confirm_requeue'),
        action: 'requeue',
        display: true
      }
    },
    confirmRequeue: function () {
      if (this.activeRequest && this.activeRequest.call) {
        RequestService.requeue(this.activeRequest.call.id)
          .then(() => {
            this.showToast(this.$t('evocall.request.actions.requeued'), this.$store.state.successToastOptions)
            EventBus.$emit('REQUEST_REQUEUED', {request: this.activeRequest})
            this.$store.commit(`${this.waitingRoomModuleKey}/RESET_ACTIVE_REQUEST`)
            this.$store.commit(`${this.waitingRoomModuleKey}/SET_ACTIVE_APPOINTMENT_UNSAVED_PERSON_CHANGES`, {hasUnsavedChanges: false})
            this.$store.commit(`${this.waitingRoomModuleKey}/SET_ACTIVE_APPOINTMENT_UNSAVED_APPOINTMENT_CHANGES`, {hasUnsavedChanges: false})
          })
          .catch(errors => {
            console.log(errors)
          })
      }
    },
    onClickGetBack: function () {
      if (this.getBackRoute !== null) {
        this.$router.push(this.getBackRoute)
      }
    },
    onClickMultipleAppointments: function () {
      this.$router.push({path: '/' + this.authClinicalService.slug + '/clinical/active-appointments'})
    },
    modalConfirmed: function () {
      switch (this.confirmationModalOptions.action) {
        case 'requeue':
          this.confirmRequeue()
          break
        case 'endCall':
          this.confirmEndCall()
          break
      }
      this.resetConfirmationModals()
    },
    resetConfirmationModals: function () {
      this.confirmationModalOptions = {
        message: null,
        action: null,
        display: false
      }
    },
    onRateModalClosed: function () {
      this.$store.commit(`${this.waitingRoomModuleKey}/RESET_ACTIVE_REQUEST`)
    },
    updateCallDuration: function () {
      this.callDuration = this.moment.duration(this.moment().diff(this.activeRequest.call.accepted_at))
      if (this.activeRequest && this.activeRequest.call) {
        this.secondsRemainToEnd = this.activeRequest.call.estimated_duration * 60 - this.callDuration.asSeconds()
        this.isNearEnd = this.activeRequest.call.estimated_duration * 60 - this.callDuration.asSeconds() < 600
        if (!this.hasStartedCountingTime && this.secondsRemainToEnd > 1) {
          this.hasStartedCountingTime = true
        }
      }
    },
    updateEstimatedTimeToAcceptance: function () {
      if (this.estimatedTimeUntilAcceptance !== null) {
        this.estimatedTimeToAcceptance = this.moment.duration(this.estimatedTimeUntilAcceptance.diff(this.moment()))
      }
    },
    clearCallDurationVariables: function () {
      if (this.callDurationTicker !== null) {
        clearInterval(this.callDurationTicker)
        this.callDurationTicker = null
        this.callDuration = null
      }
    },
    clearEstimatedTimeVariables: function () {
      if (this.estimatedTimeTicker !== null) {
        clearInterval(this.estimatedTimeTicker)
        this.estimatedTimeTicker = null
        this.estimatedTimeToAcceptance = null
      }
    },
    toggleBreak: function () {
      if (!this.isTogglingBreak) {
        this.isTogglingBreak = true
        let request = null
        let successCallBack = null

        if (this.activeBreak === null) {
          request = BreakService.startBreak()
          successCallBack = (_break) => {
            this.$store.commit(`${this.waitingRoomModuleKey}/SET_ACTIVE_BREAK`, {_break})
          }
        } else {
          request = BreakService.endBreak(this.activeBreak.id)
          successCallBack = (_break) => {
            this.$store.commit(`${this.waitingRoomModuleKey}/RESET_ACTIVE_BREAK`)
          }
        }

        request
          .then(successCallBack)
          .catch(errors => {
            this.showToast(this.$t('evocall.requests.something_went_wrong'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isTogglingBreak = false
          })
      }
    },
    onRequestCanceled: function () {
      setTimeout(() => {
        this.$store.commit(`${this.waitingRoomModuleKey}/RESET_PENDING_REQUEST`)
      }, 1000)
    },
    onRequestCancelOperationNotPermited: function () {
      setTimeout(() => {
        this.$store.dispatch(`${this.waitingRoomModuleKey}/RELOAD_MODULE`)
      }, 1000)
    },
    onCancelPendingRequestModalClosed: function () {
      this.isCancelingPendingRequest = false
    }
  },
  watch: {
    callHasBeenAccepted: {
      handler: function (value) {
        if (value) {
          if (this.callDurationTicker === null) {
            this.callDurationTicker = setInterval(this.updateCallDuration, 1000)
          }
        } else {
          this.clearCallDurationVariables()
        }
      },
      immediate: true
    },
    callHasEnded: function (value) {
      if (value) {
        if (this.userIsAcceptee && this.isNotInCorrectActiveAppointmentPage && document.hasFocus()) {
          this.$router.push(this.getBackRoute)
          this.showToast(this.$t('clinical.appointments.call_request_ended'), this.$store.state.successToastOptions)
        }
      }
    },
    estimatedTimeUntilAcceptance: {
      handler: function (value) {
        if (value !== null) {
          if (this.estimatedTimeTicker === null) {
            this.estimatedTimeTicker = setInterval(this.updateEstimatedTimeToAcceptance, 1000)
          }
        } else {
          this.clearEstimatedTimeVariables()
        }
      },
      immediate: true
    },
    pendingRequest: function (value) {
      if (value === null) {
        this.isCancelingPendingRequest = false
        this.clearEstimatedTimeVariables()
      }
    },
    activeRequest: function (value) {
      if (value === null) {
        this.clearCallDurationVariables()
      }
    },
    '$route': {
      handler: function (to, from) {
        this.currentRoute = to
      },
      immediate: true
    }
  },
  beforeDestroy: function () {
    this.clearCallDurationVariables()
    this.clearEstimatedTimeVariables()
  }
}
</script>

<style lang="scss">

@mixin mobile {
  @media (max-width: 768px) {
    @content;
  }
}

.svg-kpi {
  filter: invert(46%) sepia(13%) saturate(9%) hue-rotate(23deg) brightness(90%) contrast(99%);
}

.kpi-content {
  font-size: 1.25rem;
  font-weight: bold;
  vertical-align: text-bottom;
}

//--- CSS for information displayed on pending appointment ---
.container_call {
  display: flex;
  width: 100%
}

.info_call_left {
  flex: 1.5;
  display: flex;
  flex-direction: column
}

.info_call_left_top {
  flex: 1;
}

.info_call_left_bottom {
  flex: 1;
}

.info_call_right {
  flex: .1;
  align-self: center;
  padding-right: 15px
}

//---END of CSS for information displayed on pending appointment ---

.collapsable-div {
  position: fixed;
  height: 8rem;
  display: flex;
  align-items: center;
  padding-left: 0.35rem;

  i {
    font-size: 24px;
    color: $evollu-dark;
  }
}
.minimized-call-no-height {
  height: unset !important;
}
.minimized-call {
  position: fixed;
  height: 8rem;
  right: 0;
  z-index: 9;
  transition: 0.7s;

  .near-end-bar {
    height: 10px;
    margin: 0 !important;
  }

  .near-end-yellow {
    background: #c49d29;
  }

  .near-end-yellow-text {
    color: #c49d29;
  }

  .near-end-red {
    background: #c5253a;
  }

  .near-end-red-text {
    color: #c5253a;
  }

  &.pill-collapse {
    transform: translateX(95%);
  }

  &.not-in-correct-active-appointment {
    .appointment-call-minimized {
      background-color: rgb(255, 145, 0) !important;
      color: white;
    }

    .text-success {
      color: white !important;
    }

    .collapsable-div {
      i {
        color: white;
      }
    }

  }

  .appointment-call-minimized {
    padding: 1rem;
    border-bottom-left-radius: 3rem;
    -moz-box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);;
    -webkit-box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);;
    box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);
    display: flex;
    height: 100%;

    &.default {
      background-color: #eee;
      width: 22.5vw;
      justify-content: center;
      align-items: center;

      .active-appointment-warning {
        padding: 0rem 1.25rem;
        text-align: center;
        cursor: pointer;

        &:hover {
          font-weight: bold;
          color: $evollu-dark;
        }
      }

      #btn-create-request {
        padding: 1.5rem !important;
      }
    }

    &.pending {
      background-color: #eee;
      width: 35vw;
      padding-left: 3.5rem;
      justify-content: flex-start;
      align-items: center;

      .call-informations-wrapper {
        flex-grow: 1;

        .call-informations {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .estimated-waiting-time {
            max-width: 30%;
            padding-top: 5px;

            .time-unit {
              font-size: 1.75rem;
            }

            .time-unit-separator {
              padding-top: 5px;
            }

            .time-unit-desc {
              position: relative;
              font-size: 11px;
              top: -10px;
            }
          }
        }
      }

      .cancel-call-wrapper {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;

        #btn-cancel {
          width: 4rem;
          height: 4rem;
          border-radius: 2rem;
          background-color: #c5253a !important;

          .va-icon.fa-phone {
            transform: rotate(135deg) !important;
          }
        }
      }

    }

    &.active {
      background-color: $evollu-gray-dark;
      color: white;
      width: 35vw;
      padding-left: 3.5rem;
      flex-direction: column;
      justify-content: center;

      .call-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .call-informations-wrapper {
          flex-grow: 1;

          .call-informations {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 1rem;

            .call-user {
              color: #c7c7c8;
            }

            .call-duration {
              font-size: 1.35rem;
              width: 25%;
              text-align: center;
            }
          }

          .call-actions {
            font-size: 13px;
            color: #6E6E6E;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 0.5rem;

            .call-action-buttons {
              display: flex;
              justify-content: space-between;
              width: 15%;
            }

            .v-popover:hover {
              color: #29c4a9;
            }

            i:not(.fa-warning) {
              font-size: 18px;
              cursor: pointer;
            }

            .near-end {
              color: #c49d29;
            }
          }
        }

        .end-call-wrapper {
          width: 30%;
          display: flex;
          justify-content: center;
          align-items: center;

          #btn-dismiss {
            width: 4rem;
            height: 4rem;
            border-radius: 2rem;
            background-color: #c5253a !important;

            .va-icon.fa-phone {
              transform: rotate(135deg) !important;
            }
          }
        }
      }

      .unsaved-changes-wrapper {
        padding-right: 2rem;
      }
    }

    @include mobile {
      &.pending, &.active {
        width: 100%;
        padding: 0.5rem;
      }

      &.default {
        width: 100%;
      }
    }

  }

  @include mobile {
    position: static;
    z-index: 0;
    top: auto;
    right: auto;
    border-radius: 3rem;
    margin-top: 1rem;
    margin-bottom: 1rem;

    .collapsable-div {
      display: none;
    }
  }

}
</style>
